import { Controller } from "@hotwired/stimulus"

// Converts checkboxes to slideon toggle switches
// Usage:
//   div data-controller="switch"
//     input type="checkbox" data-switch-target="toggle"
//
// With platform checkboxes controlling main switch:
//   div data-controller="switch"
//     input type="checkbox" data-switch-target="toggle main"
//     input type="checkbox" data-switch-target="platform"
//     input type="checkbox" data-switch-target="platform"
//
// Options via data attributes:
//   data-switch-color-value="success" (primary, secondary, success, danger, warning, info, dark)
//   data-switch-size-value="sm" (xs, sm, md, lg, xl)

export default class extends Controller {
  static targets = ["toggle", "main", "platform"]
  static values = {
    color: { type: String, default: "primary" },
    size: { type: String, default: "md" }
  }

  connect() {
    this.toggleTargets.forEach(checkbox => this.initSwitch(checkbox))
  }

  initSwitch(checkbox) {
    if (checkbox.closest('.slideon')) return // Already initialized

    const wrapper = document.createElement('label')
    wrapper.className = `slideon slideon-${this.sizeValue} slideon-${this.colorValue}`

    const slider = document.createElement('span')
    slider.className = 'slideon-slider'

    checkbox.parentNode.insertBefore(wrapper, checkbox)
    wrapper.appendChild(checkbox)
    wrapper.appendChild(slider)
  }

  // Called when platform checkboxes change
  platformTargetConnected(element) {
    element.addEventListener('change', () => this.syncMainFromPlatforms())
  }

  syncMainFromPlatforms() {
    if (!this.hasMainTarget) return

    const anyChecked = this.platformTargets.some(checkbox => checkbox.checked)
    this.mainTarget.checked = anyChecked
  }
}
